import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
	components: {
	},
})
export default class String extends Vue {
	@Prop() model!: string
	@Prop() name!: string

	newModel!: string

	async created() {
		this.newModel = this.model
	}

	onInput(event) {
		const value = event.target.value
		this.$emit('input', this.name, value)
	}
}
